import { RouteRecordRaw } from 'vue-router';
import Home from '@/pages/Home.page.vue';
import Contact from '@/pages/Contact.page.vue';
import Menu from '@/pages/Menu.page.vue';
import Services from '@/pages/Services.page.vue';
import Photos from '@/pages/Photos.page.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
  },
  {
    path: '/menu',
    name: 'Menu',
    component: Menu,
  },
  {
    path: '/photos',
    name: 'Photos',
    component: Photos,
  },
  {
    path: '/services',
    name: 'Services',
    component: Services,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/pages/NotFound.page.vue'),
  },
];
export default routes;
